<template>
  <section>
    <!-- Pizarra / Porteria -->
    <div class="chalkboard-goal">
      <div class="is-bordered-box-shadow-main">
        <SoccerChalkboard
          analysis-type="offensive"
          section-type="team"
          :plays="chalkboardPlays"
          :categories="translatedOffensiveCategories"
          :games="chalkboardGames"
          :players="seasonPlayers"
          :team="team.team_id"
          :playValuesIndex="teamStatsPlayIndexes"
          @changePerspective="onChangePerspectiveSoccerChalkboard"
          @changeSelectAll="onChangeSelectAllSoccerChalkboard"
          @changeCategory="onChangeCategorySoccerChalkboard"
        />
      </div>
      <div>
        <SoccerGoal
          :players="seasonPlayers"
          :plays="goalPlays"
          section-type="team"
          type="offensive"
          :teams="seasonTeams"
          @changeCategory="onChangeCategorySoccerGoal"
        />
      </div>
    </div>
    <!-- Timeline -->
    <!--    <div class="columns">-->
    <!--      <div class="column"></div>-->
    <!--    </div>-->
    <!-- Jugarores Destacados -->
    <div>
      <nav class="level">
        <div class="level-left">
          <div class="title-section" id="jugadores-destacados-ofensivo" v-observe-visibility="visibilityChanged">
            <h1>{{ $t('featured_players.title') }}</h1>
          </div>
        </div>
        <div class="lefel-right">
          <TypeCategoryStats />
        </div>
      </nav>

      <div class="columns is-multiline is-centered">
        <div
          class="column"
          v-for="featuredPlayersCategory in featuredPlayersCategories"
          :key="featuredPlayersCategory.id"
        >
          <FeaturedPlayer :data="featuredPlayersCategory" :plays="playsStack" :players="playersTeam" />
        </div>
      </div>
    </div>
    <!-- Estadisticas -->
    <div>
      <nav class="level">
        <div class="level-left">
          <div
            class="title-section-2"
            id="estadistica-total-local-vs-visitante"
            v-observe-visibility="visibilityChanged"
          >
            <h1>{{ $t('local_vs_away.title') }}</h1>
          </div>
        </div>
        <div class="lefel-right">
          <TypeCategoryStats />
        </div>
      </nav>
      <div class="is-centered is-bordered-box-shadow-main local-vs-away">
        <div v-for="(obj, key) in localVsVisitorData" :key="key">
          <div class="donut-statistics-container">
            <div class="subtitle-section">{{ $t(obj.translationKey) }}</div>
            <StatisticDonutChart
              :data="obj.data[0] + obj.data[1] === 0 ? [] : obj.data"
              :category="obj"
              style="width: 200px; margin: 0 auto;"
              :category-ids="obj.categoryIds"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- TABLAS / GRAFICAS -->
    <div>
      <nav class="level">
        <div class="level-left">
          <div class="title-section" id="categorias-ofensivas" v-observe-visibility="visibilityChanged">
            <h1 class="is-size-4-mobile has-text-centered-mobile">{{ $t('table.offensive.title') }}</h1>
          </div>
        </div>
        <div class="lefel-right">
          <TypeCategoryStats />
          <BField class="is-hidden-mobile" v-if="false">
            <BRadioButton v-model="viewData" native-value="table">
              <BIcon icon="table-large"></BIcon>
            </BRadioButton>
            <BRadioButton v-model="viewData" native-value="pie">
              <BIcon icon="chart-pie"></BIcon>
            </BRadioButton>
          </BField>
        </div>
      </nav>
      <div v-if="viewData == 'table'">
        <TeamDataTable
          :data="translatedTableData"
          :columns="getColumns()"
          :expandedRows="expandedRows"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
        />
        <DataMobileTable
          is-selector-hidden
          :data="translatedTableData"
          :columns="getColumns()"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
          @openSubcategory="onOpenSubcategory"
          @changeSubcategory="onChangeSubcategory"
        />
      </div>
      <div v-else-if="viewData == 'pie'">
        <h1>Graficas de PIE</h1>
      </div>
    </div>
  </section>
</template>

<script>
import FeaturedPlayer from '@/components/Elements/FeaturedPlayers';
import StatisticDonutChart from '@/components/Elements/Charts/Donut/Statistics';
import TeamDataTable from '@/components/Elements/DataTable';
import DataMobileTable from '@/components/Elements/DataMobileTable';
import TypeCategoryStats from '@/components/Elements/TypeCategoryStats';
import SoccerChalkboard from '@/components/Elements/SoccerChalkboard';
import SoccerGoal from '@/components/Elements/SoccerGoal';
import tableConfig from '@/data/team/offensiveTableData';
import offensiveChalkboardCategories from '@/data/team/offensiveChalkboardCategories';
import teamStatsPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import { mapState, mapGetters, mapMutations } from 'vuex';
import {
  analisisDeEquipoSeccionVista,
  analisisDeEquipoCategoriasDeTabla,
  analisisDeEquipoTablaGrafica,
  analisisDeEquipoVistaPizarra2D3D,
  analisisDeEquipoSeleccionTodoPizarra,
  analisisDeEquiposCategoriaDePizarra,
  analisisDeEquipoCategoriasPorteria,
  analisisDeEquipoDetallesCategoria,
  analisisDeEquipoDetallesSubcategoria,
} from '@/utils/analytics/teams';
import translatedTableDataMixin from '@/utils/mixins/translated-table-data';

export default {
  components: {
    FeaturedPlayer,
    TypeCategoryStats,
    StatisticDonutChart,
    TeamDataTable,
    DataMobileTable,
    SoccerChalkboard,
    SoccerGoal,
  },
  mixins: [translatedTableDataMixin],
  data() {
    return {
      viewData: 'table',
      columns: tableConfig.columns,
      // expandedRows: tableConfig.expandedRows,
      playersTeam: [],
      offensiveChalkboardCategories,
      teamStatsPlayIndexes: teamStatsPlayIndexes(),
    };
  },
  async created() {
    try {
      this.playersTeam = await this.$store.dispatch('playersGeneral/getPlayersBySeasonAndTeam', {
        teamId: this.$route.params.teamId,
      });
    } catch (e) {
      console.error(e);
    }
  },
  watch: {
    viewData(newValue) {
      analisisDeEquipoTablaGrafica(this.seasonId, this.teamId, this.section, newValue);
    },
    basePlaysStack: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.setPlaysForGames(newValue);
        }
      },
    },
  },
  computed: {
    ...mapState('teamsOffensive', ['categories', 'featuredPlayersCategories', 'basePlaysStack']),
    ...mapGetters('teamsOffensive', [
      'tableData',
      'localVsVisitorData',
      'goalPlays',
      'chalkboardPlays',
      'chalkboardGames',
    ]),
    ...mapGetters('teamsGeneral', {
      playsGoal: 'getPlaysGoal',
      seasonTeams: 'teamsForAnalysis',
      team: 'team',
      teamId: 'teamId',
    }),
    ...mapGetters('teamsGeneral', {
      plays: 'getPlays',
    }),
    ...mapGetters('teamsOffensive', {
      playsStack: 'getPlaysStack',
    }),
    ...mapGetters('playersGeneral', ['seasonPlayers']),
    ...mapGetters('gamesGeneral', ['seasonGames']),
    ...mapGetters({ seasonId: 'filterGeneral/getSeasonId', section: 'filterGeneral/getCategoryTypeName' }),
    translatedOffensiveCategories() {
      this.offensiveChalkboardCategories.forEach(category => {
        category.name = this.$t(category.translationKey);
      });
      return this.offensiveChalkboardCategories;
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setPlaysForGames']),
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        const sectionName = entry.target.id;
        analisisDeEquipoSeccionVista(this.seasonId, this.teamId, this.section, sectionName);
      }
    },
    getColumns() {
      return this.getTranslatedColumns(tableConfig.columns);
    },
    onShowDetails(category) {
      analisisDeEquipoCategoriasDeTabla(this.seasonId, this.teamId, category, this.section, 'mostrar');
    },
    onHideDetails(category) {
      analisisDeEquipoCategoriasDeTabla(this.seasonId, this.teamId, category, this.section, 'ocultar');
    },
    onChangePerspectiveSoccerChalkboard(value) {
      analisisDeEquipoVistaPizarra2D3D(this.seasonId, this.teamId, this.section, value);
    },
    onChangeSelectAllSoccerChalkboard(value) {
      analisisDeEquipoSeleccionTodoPizarra(this.seasonId, this.teamId, this.section, value);
    },
    onChangeCategorySoccerChalkboard(value) {
      analisisDeEquiposCategoriaDePizarra(this.seasonId, this.teamId, this.section, value.name, value.checked);
    },
    onChangeCategorySoccerGoal(value) {
      analisisDeEquipoCategoriasPorteria(this.seasonId, this.teamId, this.section, value.name, value.checked);
    },
    onOpenSubcategory(category) {
      analisisDeEquipoDetallesCategoria(this.seasonId, this.teamId, this.section, category);
    },
    onChangeSubcategory(subcategory) {
      analisisDeEquipoDetallesSubcategoria(this.seasonId, this.teamId, this.section, subcategory);
    },
  },
};
</script>

<style scoped lang="scss">
div.is-bordered-box-shadow-main {
  border-radius: 20px;
}

.donut-statistics-container {
  display: flex;
  flex-direction: column;
  height: 350px;
  justify-content: space-between;
}

.chalkboard-goal {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 16px;

  @media screen and (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
}

.local-vs-away {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-top: 20px;

  & > div {
    width: 300px;
  }
}
</style>
